import React from "react";
import PropTypes from "prop-types";
import {
    ButtonContainer,
    CloseButton,
    Content,
    Header,
    Image,
    StyledAlert,
} from "./style";
import CloseIcon from "~/static/images/icons/close.svg";
import DefaultButton from "../Button/DefaultButton";
import IconButton from "../Button/IconButton";

const Alert = (props) => {
    return (
        <StyledAlert>
            <CloseButton>
                <IconButton
                    onClick={props.onClose}
                    rounded
                    icon={CloseIcon}
                    iconSize={10}
                    size={26}
                    appearance="subtle"
                />
            </CloseButton>
            {props.image ? (
                <Image>
                    <img src={props.image} style={{ height: 80, width: 80 }} />
                </Image>
            ) : null}
            <Header>{props.header}</Header>
            <Content>{props.text}</Content>
            <ButtonContainer>
                {props.buttons ? (
                    props.buttons
                ) : (
                    <DefaultButton
                        onClick={props.onClose}
                        appearance="default"
                        block
                    >
                        Hinweis schließen
                    </DefaultButton>
                )}
            </ButtonContainer>
        </StyledAlert>
    );
};

Alert.defaultProps = {
    header: "",
    text: "",
    image: null,
    onClose: () => {},
};

Alert.propTypes = {
    header: PropTypes.any,
    text: PropTypes.any,
    buttons: PropTypes.array,
    image: PropTypes.any,
    onClose: PropTypes.func,
};

export default Alert;
